import React,{useEffect,useState} from 'react';
import './comp_marksheet_pro_one.css';
import logoImg from '../assets/images/logo.png';
import ResPicDef from '../assets/images/schoo_pic.png';
import {bindEdit} from '../function_lib/common_lib';
import { setRegion } from 'react-geocode';


function exportPdf(pageType) {
    var whe = window.innerHeight;
    var wwid = window.innerWidth;

    let data = document.getElementById("divPrintMarkSheetContentBulk").innerHTML;
    /*
    alert(data);
    var doc = new DOMParser().parseFromString(data, "text/xml");

    alert(doc.getElementsByTagName("<div>")[1]);
    */
    var printWindow = window.open('', '', 'width=' + (wwid - 20) + ',height=' + (whe - 10) + '');
    printWindow.document.write('<html><head><title>Export Data</title>');
    //printWindow.document.write('<link rel="stylesheet" href="~/plugins/fontawesome-free/css/all.min.css">');
    printWindow.document.write('<link rel="stylesheet" href="https://code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css">');
    printWindow.document.write('<link rel="stylesheet" href="https://cdn.datatables.net/1.12.1/css/jquery.dataTables.min.css">');
    printWindow.document.write('<link rel="stylesheet" href="comp_marksheet_pro_one.css?20042025.09233">');
    printWindow.document.write('<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700">');
    if(pageType==="1"){
        printWindow.document.write('<style>@page { size: landscape; }table, th, td {border: 0.5px solid;}table{width:100%;border-spacing:0;}</style>');
    }else{
        printWindow.document.write('<style>table, th, td {border: 0.5px solid;}table{width:100%;border-spacing:0;}</style>');
    }
    
    
    printWindow.document.write('</head><body >');
    printWindow.document.write(data);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    //alert(printWindow.document.getElementById("exp_body").innerHTML);
    //printWindow.document.getElementById("exp_body").removeAttribute("style");
    //delete cell from table
    // let tbList = printWindow.document.getElementById("ptrTable");
    // let tbRow = tbList.rows;
    // //alert(tbRow.length);
    // for (let i = 0; i < tbRow[0].cells.length; i++) {
    //     var str = tbRow[0].cells[i].innerHTML;
    //     //alert(str);
    //     if (str.search("Action") != -1) {
    //         for (var j = 0; j < tbRow.length; j++) {

    //             // Deleting the ith cell of each row
    //             tbRow[j].deleteCell(i);
    //         }
    //     }
    // }

    setTimeout(function () {
        printWindow.print();
    }, 500);
    return false;
}

const Comp_Marksheet_Bulk_Print=(props)=>{
    const [examSubjects,setExamSubjects]=useState([]);
    const [examRoll,setExamRoll]=useState("");
    const [attend,setAttend]=useState("")
    const [mainResult,setMainResult]=useState("");

    useEffect(()=>{
        // alert(props.studentPrintMarksBulk.length);
        if(props.studentPrintMarksBulk.length>0){
            let _tmpStudentPrintMarks=JSON.parse(props.studentPrintMarksBulk[0]["student_result_js"])
          
           let tmpMarks={}
           for(let i=0;i<_tmpStudentPrintMarks.length;i++){
            //alert(_tmpStudentPrintMarks[i]["subject_marks"]);
            setExamSubjects(_tmpStudentPrintMarks[i]["subject_marks"]);
            break;
           }
         
        //    let totalDays=0;
        //    let totalPresent=0;
        //    for(let i=0;i<props.studentPrintMarks.length;i++){
        //     setExamRoll(props.studentPrintMarks[i]["roll_number"])
        //     totalDays+=parseInt(props.studentPrintMarks[i]["attend_total"]);
        //     totalPresent+=parseInt(props.studentPrintMarks[i]["attend_present"]);
            
        //     if(props.studentPrintMarks[i]["exam_nm"]==="Final Exam"){
        //         setMainResult(props.studentPrintMarks[i]["result_pass"]);
        //     }
            
        //    }
        //    setAttend(totalPresent+"/"+totalDays);


        }
       
    },[props.studentPrintMarksBulk])
    return(
        <div className="modal fade bd-example-modal-xl"  id="divPrintMarkSheetBulk" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-xl" role="document">
      <div className="modal-content">
      <div className="modal-header bg-primary">
          <h5 className="modal-title text-white" id="exampleModalLabel">Export Report</h5>
          <a href={"javascript:void(0)"} onClick={()=>exportPdf(props.pageType)} className="btn btn-sm btn-danger float-right">Export/Print</a>

          <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" className="text-white">&times;</span>
          </button>
        </div>
     
        <div id="divPrintMarkSheetContentBulk" className="modal-body">
        {props.studentPrintMarksBulk.map((main1,mainIndex1)=>{
            let _studentPrintMarks=JSON.parse(main1["student_result_js"]);
            let classCondi= _studentPrintMarks[0]["class_name"];
            
            let _rollNo="";
            let _totalDays=0;
            let _totalPresent=0;
            let _mainResult="";
            for(let r=0;r<_studentPrintMarks.length;r++){
                _rollNo=_studentPrintMarks[r]["roll_number"];
                _totalDays+=parseInt(_studentPrintMarks[r]["attend_total"]);
                _totalPresent+=parseInt(_studentPrintMarks[r]["attend_present"]);

                if(_studentPrintMarks[r]["exam_nm"]==="Final Exam"){
                    _mainResult=_studentPrintMarks[r]["result_pass"]
                }
                
            }
            
            //alert(JSON.stringify(_studentPrintMarks));
            
            
        return (<div class="report-card akshatinternational">
        <div class="header">
            <img src={logoImg} alt="School Logo" class="logo"/>
            <img src={ResPicDef} alt="School Emblem" class="logo-right"/>
            <div class="school-name">CITY MONTESSORI HIGH SCHOOL</div>
            <div class="school-address">MP Board, Affiliation No. 21128264, Dise Code: 23210702717</div>
            <div class="school-info">Indira Nagar, Ujjain (M.P.)</div>
            <div class="school-info">Email: citymontessori786@gmail.com</div>
            <div class="school-info">Website: www.citymontessorihighschool.in</div>
        </div>

        <div class="report-title">ANNUAL REPORT CARD</div>
        <div class="academic-session">Academic Session: {_studentPrintMarks[0]["session_name"]}</div>
        {/* <div class="academic-session">CLASS: {props.editItem["class_name"]+" Sec."+props.editItem["section"]}</div> */}

        <table class="student-info">
            <tr>
                <th colspan="3"><center>CLASS: {_studentPrintMarks[0]["class_name"]+" Sec."+main1["section"]}</center></th>
                
                
            </tr>
            <tr>
                <td>Name:<b>  {main1["student_name"]}</b></td>
                <td>Roll No.<b>  {_rollNo}</b></td>
                
                <td>Scholar No.:<b>  {main1["scholar_no"]}</b></td>
               
            </tr>
            <tr>
            <td>Father's Name:<b>  {main1["father_name"]}</b></td>
            <td>Date of Birth:<b>  {main1["fmt_dob"]}</b></td>
            <td>SSMID No.:<b>  {main1["stu_ssmid"]}</b></td>
                
              
               
               
            </tr>
            <tr>
            <td>Mother's Name:<b>  {main1["mother_name"]}</b></td>
            
            <td>Mobile No.:<b>  {main1["whats_no"]}</b></td>
                <td>Aadhar No.:<b>  {main1["stu_aadhaar_no"]}</b></td>
                
            </tr>
           
        </table>

        <div class="academic-section">
            <div class="academic-header">Academic Part</div>
            <table class="academic-table">
                <tr>
                    <th rowspan="2" colSpan={"2"}>Subjects</th>
                    {_studentPrintMarks.map((item,index)=>{
                        return <th>{item["exam_nm"]}</th>
                    })}
                  
                </tr>
                <tr>
                    {_studentPrintMarks.map((item,index)=>{
                        return <th>{item["outs_marks"]+" Marks"}</th>
                    })}
                </tr>
              
             {examSubjects.map((item,index)=>{
                
                if(item["academic_part"]==="Academic"){
                    let subjectGroup="";
                    subjectGroup=item?.subject_group;
                    let mapArr=[];
                    {_studentPrintMarks.map((itemMarks,indexMarks)=>{
                        let subjectsMarks=itemMarks["subject_marks"];
                        for(let s=0;s<subjectsMarks.length;s++){
                            if(subjectsMarks[s]["subject_name"]===item["subject_name"]){
                                //item.subject_w_outs_marks=item["subject_name"]+"-"+itemMarks["total_marks"];
                                mapArr.push({outs_marks:itemMarks["outs_marks"],marks_obt:subjectsMarks[s]["obtain_marks"],total_marks:subjectsMarks[s]["total_marks"]})
                            }
                        }
                    })}

                    let  needTdEx=true;
                    if(classCondi.trim()==="7th" || classCondi==="6th"){
                        if(item["subject_name"].trim()==="Drawing"){
                            needTdEx=false;
                        }
                        
                    }
                   
                    return <tr>
                        {subjectGroup!=="" && subjectGroup!=="N"?<td rowSpan={"2"}>{subjectGroup}</td>:''}
                        <td>
                            {/* {item["subject_name"]} {JSON.stringify(item)} */}
                        {item["subject_name"]}-{mapArr[mapArr.length-1]["total_marks"]}
                        </td>
                        {subjectGroup==="N" && needTdEx===true?<td></td>:''}
                        {mapArr.map((displayObt,dispIndex)=>{
                            let displayMarks=displayObt["marks_obt"];
                            if(displayObt["total_marks"]==="0"){
                                displayMarks="";
                            }else if(displayMarks==="-1"){
                                displayMarks="Absent";
                            }
                            //alert(displayObt["total_marks"]);
                            if(displayObt["total_marks"]!=="0" && (String(displayObt["outs_marks"])!==String(displayObt["total_marks"]))){
                                //displayMarks=displayMarks+" / "+displayObt["total_marks"];
                                displayMarks=displayMarks;
                            }
                            // if(displayObt["total_marks"]==="10" || displayObt["total_marks"]===10){
                            //     displayMarks=displayMarks+"/"+"10";
                            // }

                            return <>
                           
                            <td>{displayMarks}</td>
                            </>
                        })}
                    </tr>

                }
               
             })}
            <tr>
                <td><b>Total</b></td>
                <td></td>
                {_studentPrintMarks.map((ptrTotal,ptrIndex)=>{
                    return <td><b>{ptrTotal["obtain_marks"]+" / "+ptrTotal["total_marks"]}</b></td>
                })}
            </tr>
              
              
            </table>
        </div>

        {/* <table class="grand-total">
            <tr>
                <td>Grand total</td>
                <td>468/500</td>
                <td>Percentage</td>
                <td>93.6%</td>
                <td>Total Grade</td>
                <td>A1</td>
            </tr>
        </table> */}
   
          <div className='academic-section'>
            <table class="academic-table">
            <thead> <tr><th colSpan={"5"}>
                <center> Co-Scholastic Activities
              
              (3 Point Grading Scale A,B,C)</center>
               
                    </th></tr></thead>
               
                <tr>

                    <th></th>
                    {examSubjects.map((item,index)=>{
                        if(item["academic_part"]==="Co-Scholastic"){
                            return <th>{item["subject_name"]}</th>
                        }
                        
                    })}
                   
                   
                </tr>

{/* scholastic subjects */}
{_studentPrintMarks.map((itemResult,indexResult)=>{
   // alert(itemResult["exam_nm"]);
    if(itemResult["exam_nm"]==="Terminal Exam" || itemResult["exam_nm"]==="Half Yearly Exam" ||
    itemResult["exam_nm"]==="Final Exam"){
        let subjectsMarks=itemResult["subject_marks"]
        //alert(JSON.stringify(subjectsMarks));
        return <tr>
            <td>{itemResult["exam_nm"]}</td>
            {subjectsMarks.map((itemSub,subIndex)=>{
                if(itemSub["academic_part"]==="Co-Scholastic"){
                    return <td>{itemSub["grade_applied"]!=="NA"?itemSub["grade_applied"]:''}</td>
                }
                
            })}
        </tr>
    }
})}

              
            </table>
  </div>


        <table class="attendance-table">
            <tr>
                <td>Attendance: <b>{_totalPresent+"/"+_totalDays}</b></td>
                <td>Final Result: <b>{_mainResult}</b></td>
                <td>Remark: <b>School will reopen on 6th April, 2026</b></td>
                
            </tr>
        </table>

<div class="academic-section">
        <table class="academic-table">
            <thead>
                <tr>
                <th><center>Exams</center></th>
                <th><center>Obt./Total</center></th>
                <th><center>Percentage</center></th>
                <th><center>Division</center></th>
                <th><center>Grade</center></th>
                <th><center>Rank</center></th>
                <th><center>Remark</center></th>
                </tr>
            </thead>
            <tbody>
                {_studentPrintMarks.map((lastLine,lastIndex)=>{
                     if(lastLine["exam_nm"]==="Terminal Exam" || lastLine["exam_nm"]==="Half Yearly Exam"
                     || lastLine["exam_nm"]==="Final Exam"
                     ){
                        //alert(JSON.stringify(lastLine))
return  <tr>
<td>{lastLine["exam_nm"]}</td>
<td>{lastLine["obtain_marks"]}/{lastLine["total_marks"]}</td>
<td>{(lastLine["display_at"]!=="not" && lastLine["marks_per"]!="0" && lastLine["obt_grade"]!=="F")?lastLine["marks_per"]+"%":'-'}</td>
<td>{(lastLine["display_at"]!=="not" && lastLine["obt_grade"]!=="F")?lastLine["obt_division"]+" ":'-'}</td>
<td>{lastLine["obt_grade"]}</td>
<td>{(lastLine["display_at"]!=="not" && lastLine["obt_grade"]!=="F")?<>{lastLine["rank"]!=="0"?lastLine["rank"]+" ":'-'}</>:'-'} </td>
<td>{lastLine["remarks"]}</td>
</tr>
                     }

                })}
              
            </tbody>
        </table>    
            
    
        </div>

        <div class="signature-section">
            <div class="signature">
                <div class="signature-line"></div>
                <div style={{"padding-bottom":"2px","font-size":"12px"}}><b>PARENT'S SIGNATURE</b></div>
            </div>
            <div class="signature">
                <div class="signature-line"></div>
                <div style={{"padding-bottom":"2px","font-size":"12px"}}><b>CLASS TEACHER'S SIGNATURE</b></div>
            </div>
            <div class="signature">
                <div class="signature-line"></div>
                <div style={{"padding-bottom":"2px","font-size":"12px"}}><b>PRINCIPAL'S SEAL AND SIGNATURE</b></div>
            </div>
        </div>
       
        <div class="grade-scale-section">
            <table class="grade-scale">
                {/* <tr>
                    <th colspan="9">Scholastic Subject</th>
                    <th colspan="6">Co-Scholastic Topics</th>
                </tr> */}
                <tr>
                    <th>Marks Range</th>
                    <th>91-100</th>
                    <th>81-90</th>
                    <th>71-80</th>
                    <th>61-70</th>
                    <th>51-60</th>
                    <th>41-50</th>
                    <th>33-40</th>
                    <th>0-32/Fail</th>
                    <th>Grace</th>
                    <th>Grade Range</th>
                    <th>5</th>
                    <th>4</th>
                    <th>3</th>
                    
                </tr>
                <tr>
                    <th>Grade</th>
                    <td>A1</td>
                    <td>A2</td>
                    <td>B1</td>
                    <td>B2</td>
                    <td>C1</td>
                    <td>C2</td>
                    <td>D</td>
                    <td>F</td>
                    <td>G</td>
                    <th>Grade</th>
                    <td>A</td>
                    <td>B</td>
                    <td>C</td>
                   
                </tr>
            </table>
        </div>

    </div>)
})}

    </div>

    </div>
      </div>
      </div>
    );
}

export default Comp_Marksheet_Bulk_Print;